import React, { useState } from "react";
import logo from "../Assets/logo.png";
import whatsapp from '../Assets/wa.webp'
import { Link } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
<Link to="/">
        <img src={logo} alt="logo" className="logo" />
</Link>

        <ul className={menuOpen ? "nav-links active" : "nav-links"}>
          <li><a href="/" onClick={() => setMenuOpen(false)}>Home</a></li>
          <li><a href="/about" onClick={() => setMenuOpen(false)}>About Me</a></li>
          <li><a href="/services" onClick={() => setMenuOpen(false)}>Services</a></li>
          <li><a href="/blog" onClick={() => setMenuOpen(false)}>Blog</a></li>
          <li><a href="/contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
        </ul>

        <a href="tel:7703895964">
  <button className="call-btn">Call on: 7703895964</button>
</a>

        {/* Toggle Button */}
        <div 
          className={`hamburger ${menuOpen ? "active" : ""}`} 
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
<Link to="https://wa.me/917703895964" target="_blank">
      <img className="whatsapp" src={whatsapp}/>
</Link>

<Link to="/contact">
<button className="fix-btn">
Book an Appointment
</button>
</Link>



<div className="check-div">
  <Link to="/contact" className="check-link" style={{color:'white'}}>
  <i class="bi bi-arrow-right"></i>
  </Link>
   <a href="tel:7703895964" style={{color:'white'}}>

  <i class="bi bi-telephone-fill"></i>
   </a>

   <Link to="https://wa.me/917703895964" target="_blank" style={{color:'white'}}>
<i class="bi bi-whatsapp"></i>
   </Link>


</div>
    </nav>
  );
}

export default Navbar;